/**
 * Map deity-edge nodeId → static deity icon URL. Mirrors jnana-native's
 * `getDeityImage` (see jnana-native/src/util/constants/graph.ts and
 * src/bmScreens/playlists/selectDeityForPlaylist.tsx). All images are
 * served from /public/img/deities/ at ~128px max dimension.
 */

export enum DeityNodeIds {
  SadguruStuti = 100000,
  Ganapathy = 100243,
  Datta = 100245,
  Devi = 100247,
  Guru = 100248,
  Vishnu = 100249,
  Hanuman = 100250,
  Stotra = 100251,
  Shiva = 100252,
  Murugan = 100253,
  Mangalam = 100254,
  Ugadi = 100255,
  Mantram = 105100,
}

const BY_ID: Record<number, string> = {
  [DeityNodeIds.Datta]: 'deity-datta.png',
  [DeityNodeIds.Devi]: 'deity-durga.png',
  [DeityNodeIds.Ganapathy]: 'deity-ganapathy.png',
  [DeityNodeIds.Hanuman]: 'deity-hanuman.png',
  [DeityNodeIds.Vishnu]: 'deity-vishnu.png',
  [DeityNodeIds.Shiva]: 'deity-shiva.png',
  [DeityNodeIds.Mangalam]: 'deity-clay-light.png',
  [DeityNodeIds.Murugan]: 'deity-skanda.png',
  [DeityNodeIds.SadguruStuti]: 'deity-veena-player.png',
  [DeityNodeIds.Ugadi]: 'deity-ugadi.png',
  [DeityNodeIds.Guru]: 'deity-guru.png',
};

const DEFAULT_FILE = 'deity-om.png';

const PUBLIC_URL = (typeof process !== 'undefined' && process.env.PUBLIC_URL) || '';

/** Returns the static URL for a deity icon. Always returns something — falls back to deity-om.png. */
export function deityIconUrl(deityId?: number | null): string {
  const file = (deityId != null && BY_ID[deityId]) || DEFAULT_FILE;
  return `${PUBLIC_URL}/img/deities/${file}`;
}
